document.addEventListener('alpine:init', () => {
    Alpine.data('postcodeSearch', () => ({
        loading: false,

        initAutocomplete() {
            const input = document.getElementById('postcode');
            if (!input) return;

            let autocomplete = new google.maps.places.Autocomplete(input, {
                componentRestrictions: { country: 'uk' }
            });

            autocomplete.addListener('place_changed', () => {
                let place = autocomplete.getPlace();
                if (!place.geometry) return;

                let lat = place.geometry.location.lat();
                let lng = place.geometry.location.lng();

                this.fetchLocations(lat, lng);
            });
        },

        fetchLocations(lat, lng) {
            this.loading = true;

            fetch(indexJSVars.ajaxurl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'postcode_search',
                    lat: lat,
                    lng: lng
                })
            })
                .then(res => res.json())
                .then(data => {
                    this.loading = false;
                    if (data.success && data.data.length) {
                        // replace contents of the #locations container
                        const wrapper = document.getElementById('locations');
                        wrapper.innerHTML = data.data.map(loc => loc.html).join('');
                    } else {
                        document.getElementById('locations').innerHTML =
                            '<p>No locations found nearby.</p>';
                    }
                })
                .catch(err => {
                    console.error('AJAX error:', err);
                    this.loading = false;
                    document.getElementById('locations').innerHTML =
                        '<p>Something went wrong.</p>';
                });
        }
    }))
});
